export default __webpack_public_path__ + "static/media/avocado.9ea01784.svg";